import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { TipoRespaldoSubcategoriaDetalle } from '../_models/tipo-respaldo-subcategoria-detalle';

@Injectable({
  providedIn: 'root'
})
export class TipoRespaldoSubcategoriaDetalleService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/tiposRespaldosSubCategoriasDetalle/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TipoRespaldoSubcategoriaDetalle[] ) );
  }

  listadoPorIdSubcategoria( id: string ) {
    return this.httpClient.get( this.rutServicio + 'tipoRespaldoSubCategoria/' + id ).pipe( map( res => res as TipoRespaldoSubcategoriaDetalle[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as TipoRespaldoSubcategoriaDetalle ) );
  }

  crear( regCrear: TipoRespaldoSubcategoriaDetalle ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TipoRespaldoSubcategoriaDetalle ) );
  }

  actualizar( regActualizar: TipoRespaldoSubcategoriaDetalle ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  buscar( str: string ) {
    return this.httpClient.get( this.rutServicio + 'buscar/' + str + '/' ).pipe( map( res => res as TipoRespaldoSubcategoriaDetalle[] ) );
  }
}
